// Auto-generated address book for chain 11155111 (scripts/deployLocal.cjs writes this per deploy).
// One book per chain; src/lib/contracts.js selects among them by VITE_TARGET_CHAIN, so mainnet,
// Sepolia and local hardhat no longer overwrite one another in a single shared file.
export const IS_DEPLOYED = true;
export const CHAIN_ID = 11155111;
export const ADDRESSES = {
  HORIZON_TOKEN:      "0x07934c49068cA35Ed47E701CE94DDf512673bBC2",
  // Testnet-only public HORIZON faucet (zero address on mainnet / any non-DEPLOY_FAUCET run). The
  // dapp's "Get test tokens" panel shows a drip button only when this is set.
  HORIZON_FAUCET:     "0xD417586450023ef0b4bD91557e5b743E08D0E07b",
  HORIZON_EMISSIONS:  "0xd82da7Dd809D3EeBd940B1e0B7143ECE368Edb74",
  // The HORIZON/USDx Uniswap V3 pool. Recorded directly rather than resolved through whatever
  // happens to hold liquidity in it, because it is this app's ONLY HORIZON/USD price signal
  // (useHorizonPriceUsd) and that signal must outlive any one consumer - it was previously read
  // off the LP farm's farm-0 struct, which tied the whole app's USD pricing to a contract now
  // being retired. The pool itself is permanent; the things holding positions in it are not.
  HORIZON_WETH_POOL:  "0xfbADeD3082A19c43d204d0Fb4eF83295D6b20e17",
  USDX:            "0x5cfC959888bDD1074a6426A9F300D1f17DBb837E",
  hUSD:            "0x0000000000000000000000000000000000000000",
  WETH:            "0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14",
  SWAP_ROUTER:     "0x3bFA4769FB09eefC5a80d6E87c3B9C650f7Ae48E",
  NPM:             "0x1238536071E1c677A632429e3655c799b22cDA52",
  LENDING_POOL:    "0x5C16E211a51e9eAE01D85cbCa8785f828E25acc6",
  S_TOKEN_USDX:    "0x0000000000000000000000000000000000000000",
  S_TOKEN_hUSD:    "0x0000000000000000000000000000000000000000",
  SAVINGS_hUSD:    "0x0000000000000000000000000000000000000000",
  S_TOKEN_WETH:    "0x9377D1c836b3705EF9B141D87c7D3bef74b4c8D4",
  // Blue-chip collaterals listed alongside WETH, both NON-isolated (shared-risk pool). WBTC is
  // 8-decimal - the frontend reads every reserve's decimals off-chain rather than assuming.
  WBTC:            "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
  S_TOKEN_WBTC:    "0x0000000000000000000000000000000000000000",
  // Recorded even though the frontend enumerates reserves from the chain: scripts resolve
  // external assets through this block (devSeedPairVenue's COLLATERAL=usdc, applyLoopVenues).
  USDC:            "0x17584112c79B61E5DDb118857d751f79Ed03795F",
  S_TOKEN_USDC:    "0x9E8B4F72daA1975D49F0dE64c85916d10396C78d",
  WSTETH:          "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
  S_TOKEN_WSTETH:  "0x0000000000000000000000000000000000000000",
  // wstETH/USD is a COMPOSED feed (stETH/USD x the live Lido rate), deployed by this script rather
  // than a canonical mainnet address - recorded so the checklist and any verifier can find it.
  WSTETH_USD_FEED: "0x0000000000000000000000000000000000000000",
  // USDx's own price feed. Recorded because config/reserves.json references it as $USDX_FEED -
  // a protocol-deployed feed whose address changes every redeploy, so it cannot be pinned there.
  USDX_FEED:       "0xd3274E862312d76EEd54a09BB0bFFc4B9e859aF2",
  WETH_GATEWAY:    "0x96D7268225e9F524d4520AFB3B024CcbB6663002",
  // Native-coin deposits into ALM vaults (the vault-side counterpart to WETH_GATEWAY). Per chain,
  // this is the ONLY address that changes; the frontend reads it here and shows the native deposit
  // option on any vault whose pair holds the wrapped-native. See NativeVaultZap.sol.
  NATIVE_VAULT_ZAP: "0x91854053C51342C426bDB59361DAf83b61C9d624",
  HORIZON_VOTE_ESCROW: "0x3b7a5fefCb87C53072b9C0c6c3980A515473FBf9",
  // Curve-style per-week ve revenue distributor (entry 312). RevenueRouter's staker leg pays it and
  // calls checkpointToken; lockers claim their exact decayed weekly share here, not from the ve
  // (the ve's old Synthetix-style streaming leg was removed in the same redesign).
  HORIZON_REVENUE_DISTRIBUTOR: "0x69Afe1b3c0D2f23168f1C543521767304ecb8D5d",
  REVENUE_ROUTER:  "0x6f275CDceF8680039b4DcD2e644C203E2B3346F0",
  // BUYBACK now points at the HorizonBuybackArray (the router's re-pointed buyback target). The legacy
  // Buyback.sol is retired from production; its old frontend/indexer surface is reworked in P4.
  BUYBACK:         "0xf97A5d49769458AC087803816f3aeA7Da91401A2",
  HORIZON_BUYBACK_ARRAY: "0xf97A5d49769458AC087803816f3aeA7Da91401A2",
  HORIZON_AUCTION: "0xBfcc18c4Ad6476800bA68771475014D025A7cec6",
  // Auction input oracle: the mock on a testnet (DEPLOY_MOCK_TITANX), 0x0 on mainnet/fork until launch
  // wires the real one (deployAuctionOracle.cjs). The UI can also read it live via horizonAuction.oracle().
  HORIZON_AUCTION_ORACLE: "0x13d41b944d73F6237deC691855A01B69C823bEe7",
  // KeeperIncentives - the HORIZON top-up guaranteeing the keeper gas+premium floor. It is GenesisOwned
  // AND a HORIZON minter, so it MUST be in the book: handoverToSafe is address-book-driven, and while
  // this key was absent the handover silently skipped both its genesis transfer and its minter grant.
  KEEPER_INCENTIVES: "0x52e9A4631451d521F3C56BB154a22159FA769D83",
  // TitanX ecosystem token addresses the buyback/auction UI reads balances against. Mainnet/fork: the
  // real external tokens. Testnet (DEPLOY_MOCK_TITANX): the public-mint mocks deployed above.
  TITANX:          "0x9ea20e35033743FfdeD6B466fe7Bd253040Cc27F",
  X28:             "0xf81D622d612F4bF46BE6498fDA397C34f3A192d2",
  REFERRAL_REGISTRY: "0x2DD8D9A8Bc0955FcF16B2A736ACf4717ABdAF5d7",
  // Guardian Pools - one SafetyModule proxy per reserve (entry 165), each defending its own debt
  // market. SAFETY_MODULE_<ASSET> keying matches S_TOKEN_<ASSET>'s own convention; the lines are
  // GENERATED from the same catalogue-derived set 8b deployed, so a sixth reserve records its
  // module here without anyone editing this template.
  SAFETY_MODULE_WETH: "0x6F9C7d629CC6ea094EEC0590c3D7e6Cf1Cbd84b2",
  SAFETY_MODULE_USDC: "0x658F0339CCBBFFcfA3F2a183CC91182B2443bCE4",
  // First-loss cover pool (Feature 5, entry 214) - per COVER ASSET, not per reserve; underwrites
  // coverage lines for future protected products. Backend primitive only for now, no frontend
  // surface until the first senior product ships (Phase C, post-audit).
  FIRST_LOSS_VAULT_USDX: "0x0000000000000000000000000000000000000000",
  // Integration surfaces - immutable, stateless, no protocol authority. POOL_VIEWS is the
  // Aave-shaped read surface liquidation bots build against; WRAPPED_SUSDX is the ERC-4626
  // adapter yield aggregators discover by scanning for the standard.
  POOL_VIEWS:      "0x2B073AbD63e585D18504C6a8e028c6aCbda36fDD",
  WRAPPED_SUSDX:   "0x0000000000000000000000000000000000000000",
  // D1 (entry 208): the rest of the supply side's 4626 doorways + the vaults' lens, both
  // catalogue-derived - generated lines, like the guardian modules above.
  WRAPPED_SWETH: "0x5d3BF348fde3e3CF10c81102e9C0B484bFfDBE8F",
  WRAPPED_SUSDC: "0xBE809BFF00038758dbcDCF54DC09daD8f2aEf8fB",
  VAULT_LENS:      "0x11a0Fcaae643C3FCF872AcE041a139869324A920",
  // Leveraged looping, periphery only - holds no user funds between transactions and has no
  // pool privilege; each user delegates to it themselves.
  MULTIPLY_ROUTER: "0xe0B1f5814a1eb9005862Ab633B9c5807E02c13F7",
  // Canonical Permit2 singleton (same address every chain; MockPermit2 etched here on local). The
  // frontend signs SignatureTransfer permits against it for one-tap supply/repay/stake/lock/open.
  PERMIT2:         "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  // Trustless periphery router giving the ALM vaults a Permit2 one-tap deposit (the vaults are at
  // the code-size limit, so this lives outside them). See VaultZapPermit.sol.
  VAULT_ZAP_PERMIT: "0x1f894e0A98FE97e53f602852D058c81ACc4Acb5f",
  // Opt-in liquidation protection. Periphery, immutable, and it moves a user's collateral ONLY
  // while that user's own health factor sits below the trigger they set - so the app must read
  // per-user settings off it rather than assume anything protocol-wide.
  PROTECTION_MANAGER: "0x624bbF8c74Fe33022EAd25d23e89DdAC607D5eE8",
  // Vault system - shared infrastructure only (see step 10's own doc comment); no vault instance
  // is created by this script, so there is no VAULT_/individual-vault address to record here.
  POOL_MANAGER:       "0x4A3Dd6091C854B1d21eAd694Ed52C2532f9Ec350",
  VAULT_ORACLE_HOOK:  "0xe7D362183bDAD1b8C975FD4E687D1E26D1f47080",
  VAULT_BEACON_V3:    "0x2089cad5404661b65cbC90fFEf82DFabbf561ded",
  VAULT_BEACON_V4:    "0x8162A7a9C519049a6B33EF0DcB631847576B3ab8",
  REBALANCE_GUARD:    "0xfFFDBA59e303aF6fcBFCE6adaba57C533e1b6557",
  VAULT_FEE_MANAGER:  "0xF31Fc49FaB138324c8E56714BFD2cB5B14F4A778",
  CLEARING_V3:        "0x74a1855e4dC4e7816DDcFf382b5a87C2D586fDd5",
  CLEARING_V4:        "0xacdF018949170518460B19986bD3c2eaD78737c9",
  VAULT_FACTORY:      "0x09695AF045e078f40D2eA31675E7b1413EDf822e",
  // ve(3,3) voting layer (entry 296-298): the weekly-reset gauge and the fees-follow-votes
  // distributor. Deployed dormant - fees-follow-votes activates via a genesis sequence once vaults
  // are created and votes cast (see deployLocal's own ACTIVATE ve(3,3) print).
  GAUGE_CONTROLLER:   "0x70F221995f73FbfF52dB19D996d0eBC7f3599721",
  FEE_DISTRIBUTOR:    "0x3741D6a71762d5B07d9B6b267309D3A65667b79F",
  BRIBE_MARKET:       "0x831dfa91fE0FC74DB746b285f4105c0624B362b8",
  // Single-asset staking registry. The app enumerates this rather than carrying a hardcoded list,
  // so listing an asset is a genesis transaction and needs no frontend deploy. Deployed here (step
  // 10b) precisely so it survives a redeploy - it used to be created only by
  // scripts/createStakingVault.cjs and had to be pasted back in by hand every time.
  STAKING_VAULT_FACTORY: "0x80c9b05753C4a8A165B164497A77c92A8BE4471b",
  // Deploy block of HorizonLendingPool - the Liquidations page's event-log scan (useAllBorrowers)
  // starts from here, not block 0, since a mainnet-fork chain inherits the real chain's full
  // height and forked RPC providers commonly cap eth_getLogs to a bounded block range (e.g.
  // 50,000 blocks) - scanning from literal genesis fails outright on a fork.
  LENDING_POOL_DEPLOY_BLOCK: "11567280",
};
